export const COMPARISON_TIMEFRAME = Object.freeze({
  LAST_WEEK: "last-week",
  LAST_MONTH: "last-month",
  LAST_QUARTER: "last-quarter",
  LAST_YEAR: "last-year",
  ALL_TIME: "all-time",
});

export const COMPARISON_TIMEFRAME_OPTIONS = [
  {
    "timeframeId": 1,
    "timeframe": "last-week",
    "label": "Last Week"
  },
  {
    "timeframeId": 2,
    "timeframe": "last-month",
    "label": "Last Month"
  },
  {
    "timeframeId": 3,
    "timeframe": "last-quarter",
    "label": "Last Quarter"
  },
  {
    "timeframeId": 4,
    "timeframe": "last-year",
    "label": "Last Year"
  },
  {
    "timeframeId": 5,
    "timeframe": "all-time",
    "label": "All Time"
  }
];

export const DEMOGRAPHIC_OPTIONS = [
  {
    "gradeLevelKey": "group-k5",
    "gradeLevelValue": "K-5"
  },
  {
    "gradeLevelKey": "group-68",
    "gradeLevelValue": "K6-8"
  },
  {
    "gradeLevelKey": "group-912",
    "gradeLevelValue": "K9-12"
  },
  {
    "gradeLevelKey": "group-highed",
    "gradeLevelValue": "HighEd"
  },
  {
    "gradeLevelKey": "group-gov",
    "gradeLevelValue": "Government"
  }
];

export const REGION_OPTIONS = [
  {
    "stateCode": "All",
    "stateName": "All"
  },
  {
    "stateCode": "Non US",
    "stateName": "Non US"
  },
  {
    "stateCode": "UnIdentified",
    "stateName": "UnIdentified"
  }
];

export const TOPIC_OPTIONS = [
  {
    "topicId": 1,
    "topic": "us-politics",
    "label": "US Politics"
  },
  {
    "topicId": 2,
    "topic": "world-news",
    "label": "World News"
  },
  {
    "topicId": 3,
    "topic": "technology",
    "label": "Technology"
  },
  {
    "topicId": 4,
    "topic": "sports",
    "label": "Sports"
  },
  {
    "topicId": 5,
    "topic": "business",
    "label": "Business"
  }
];

export const METRIC_OPTIONS = [
  {
    "metricId": 1,
    "metric": "total-visitors",
    "label": "Total Visitors"
  },
  {
    "metricId": 2,
    "metric": "unique-visitors",
    "label": "Unique Visitors"
  },
  {
    "metricId": 3,
    "metric": "page-views",
    "label": "Page Views"
  },
  {
    "metricId": 4,
    "metric": "engagement-rate",
    "label": "Engagement Rate"
  },
  {
    "metricId": 5,
    "metric": "bookmarks",
    "label": "Bookmarks"
  }
]; 